import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import { CodaLine } from '@modules/accounting/interfaces/coda-line';
import CodaLineTableInput from '@shared/components/forms/inputs/coda-line-table-input/coda-line-table-input.vue';

@Component({
  name: 'bpc-coda-line-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-coda-line-table-input': CodaLineTableInput,
    'bpc-extended-filter': ExtendedFilter,
  },
})
export default class CodaLineTable extends mixins(AbstractTable) {
  tableInputCodaLine: InstanceType<typeof CodaLineTableInput> & {
    getEntities(): void;
  };

  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop({ type: String, default: null }) readonly createFormConfigName: string;
  @Prop({ type: String, default: null }) readonly editFormConfigName: string;
  @Prop({ type: Boolean, default: true }) readonly showTableHeader: boolean;

  public entity: CodaLine = null;
  public entityName = 'coda-line';
  public pluralEntityName = 'coda-lines';
  public permissionEntityNameToUse = 'codas';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  extendUpdateRowActions(entity: any) {
    // show only the edit and delete actions if the actions can be shown and the coda is not matched yet
    if (
      this.tableIsNotFilteredByTrashedElements() &&
      entity.actions.edit.show &&
      entity.status !== 'not_matched'
    ) {
      entity.actions.edit.show = false;
    }

    if (
      this.tableIsFilteredByTrashedElements() ||
      (this.tableIsNotFilteredByTrashedElements() &&
        entity.actions.softDelete.show &&
        entity.status !== 'not_matched')
    ) {
      entity.actions.softDelete.show = false;
    }
  }

  get codaLineFormConfigName() {
    if (this.entity) {
      return this.editFormConfigName ? this.editFormConfigName : this.formConfigName;
    } else {
      return this.createFormConfigName ? this.createFormConfigName : this.formConfigName;
    }
  }

  onShow(e) {
    this.onEdit(e, true);
  }
}
